import { Divider, Skeleton, Stack } from "@mui/material";
import { Constants } from "../../utils/constants";
import BorderWidget from "./border_widget";


export default function AccountInfoSkeleton() {
    return (
        <BorderWidget
            sx={{
                boxShadow: "0px 1px 3px 0px #0000001a",
                padding: {
                    xs: `calc(${Constants.Styles.spacing} * 2)`,
                    sm: `calc(${Constants.Styles.spacing} * 6)`,
                },
                borderRadius: `calc(${Constants.Styles.radius.base} + 4px)`,
                flex: 1,
            }}
        >
            <Stack
                direction={"column"}
                alignItems={"start"}
                justifyContent={"space-between"}
                spacing={"0.5rem"}
            >
                <Skeleton
                    variant="rounded"
                    height={20}
                    width={100}
                />
                <Skeleton
                    variant="rounded"
                    height={20}
                    width={240}
                />
            </Stack>
            <Skeleton
                variant="rounded"
                height={80}
                width={"100%"}
                sx={{
                    marginBlock: "1.125rem",
                }}
            />
            <Divider />
            <Skeleton
                variant="rounded"
                height={70}
                width={"100%"}
                sx={{
                    marginBlock: "1.125rem",
                }}
            />
            <Divider />
            <Skeleton
                variant="rounded"
                height={70}
                width={"100%"}
                sx={{
                    marginBlock: "1.125rem",
                }}
            />
        </BorderWidget>
    );
}